import { Box, Button, Grid, Typography } from "@mui/material"
import { ActivityListHeaderProps } from "./types"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { CaptionKeyVertical } from "../../../../../../../components/detailKeyValue/keyCaption.index"
import { icons } from "../../../../../../../utils/icons"
import { useStyles } from "./styles"
import { StatusCard } from "../statusCard"
import { NewListTooltipDetail } from "../../../../../../../components/newListTooltipDetail"
import { CustomeIconButton } from "../../../../../../../components/customeIconButton"


export const ActivityListHeader = ({ allExpand, expasnded, area, curp, department, division, rol, total, types, more }: ActivityListHeaderProps) => {

    const [seeMore, setSeeMore] = useState(false)
    const { t } = useTranslation()
    const styles = useStyles()

    return (
        <Box sx={styles.indexContainer}>
            <Box sx={styles.title}>
                <Typography variant="text_grey" fontWeight='bold'>{t('loogbook.activitiesCount')}</Typography>
                <Typography variant="text_grey" fontWeight='500'>{t('loogbook.total')} {total}</Typography>
            </Box>

            {types &&
                <Grid container spacing={1} sx={styles.grid}>
                    {types.map(type => (
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                            <StatusCard count={type.count} type={type.type} />
                        </Grid>
                    ))}
                </Grid>
            }

            {!seeMore && more &&
                <Box sx={styles.containerButon}>
                    <Box sx={styles.expandButton}>
                        <CustomeIconButton title={t(`general.${!allExpand ? 'fullScreenOpen' : 'fullScreenExit'}`)} icon={icons(!allExpand ? 'fullScreenOpen' : 'closeFullScren')} iconButtonProps={expasnded} />
                    </Box>
                    <Button sx={styles.buton} onClick={() => { setSeeMore(true) }}>{t('loogbook.buttons.seeMore')} {icons('view-more')}</Button>
                </Box>
            }

            {seeMore && more &&
                <Box>
                    <Grid container spacing={1} >
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
                            <CaptionKeyVertical center caption={t('loogbook.division')} value={division ?? 'N/A'} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
                            <CaptionKeyVertical center caption={t('loogbook.curp')} value={curp ?? 'N/A'} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
                            <CaptionKeyVertical center caption={t('loogbook.area')} value={<NewListTooltipDetail list={area || []} />} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
                            <CaptionKeyVertical center caption={t('loogbook.role')} value={rol ?? 'N/A'} />
                        </Grid>
                        <Grid item xs={12} >
                            <CaptionKeyVertical center caption={t('loogbook.department')} value={<NewListTooltipDetail list={department || []} />} />
                        </Grid>
                    </Grid>

                    <Box sx={styles.containerButon}>
                        <Box sx={styles.expandButton}>
                            <CustomeIconButton title={t(`general.${!allExpand ? 'fullScreenOpen' : 'fullScreenExit'}`)} icon={icons(!allExpand ? 'fullScreenOpen' : 'closeFullScren')} iconButtonProps={expasnded} />
                        </Box>
                        <Button sx={styles.buton} onClick={() => { setSeeMore(false) }}>{t('loogbook.buttons.seeLess')} {icons('view-less')}</Button>
                    </Box>
                </Box>
            }
        </Box>
    )
}